module.exports = __webpack_public_path__ + "static/media/cult_portal.b6484435.jpg";